
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonGeneral from '@/components/molecules/ButtonGeneral.vue'
import ButtonStrong from '@/components/molecules/ButtonStrong.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * メッセージ画面の操作ボタン(管理用)
 *   FIXME: 生徒用と共通化を検討
 */
@Component({
  components: {
    ButtonGeneral,
    ButtonStrong,
    PanelFrame,
  },
})
export default class ManageNoticeMessageLinkPanel extends Vue {
  /** 編集可能か否か */
  @Prop({ default: false })
  private isEditable!: boolean

  /** 戻るボタンクリック時のイベント */
  @Prop()
  private eventBack!: () => void

  /** 編集ボタンクリック時のイベント */
  @Prop()
  private eventEdit!: () => void

  /** 削除ボタンクリック時のイベント */
  @Prop()
  private eventDelete!: () => void
}
